import { FeatureFlags } from '@fabric-ui/components';
import { parseWidgetDataBeforeApiRequest } from '@utils/utils';
import { useAvContext } from '../../../context/AvContextProvider';
import { useExportQueryObjectWorkflow } from '../../../hooks/useExportQueryWorklflow';
import { useMetricsContextAsArray } from '../../../hooks/useMetricsContext';
import { cleanEmptyFilters } from '../../../utils/filterUtils';
import { useBuildQueryParams } from '../../Reports/hooks';
import { isHistoricalQuery } from '../CustomDashboardsUtils/utils';
import { AllTypeWidgets, HistoricalFilterMode, PivotTableTypeWidget, TableSubType, TopResults } from '../types';

export const useExportWidget = () => {
  const { featureFlags } = useAvContext();
  const { mutate: exportQueryObjectWorkflow, isPending: isExporting } = useExportQueryObjectWorkflow();
  const measurements = useMetricsContextAsArray();

  const metricsWithAliases = useBuildQueryParams({
    headCellsIds: measurements.map(({ systemName }) => systemName),
    measurements,
  });

  const exportWidget = ({ widget, globalFilters }: { widget: Exclude<AllTypeWidgets, PivotTableTypeWidget>; globalFilters: any }) => {
    const requestTop = widget.requests[0]?.top;
    const parsedWidget = parseWidgetDataBeforeApiRequest({
      widget,
      metricsWithAliases,
    });
    const { top, ...rest } = parsedWidget.requests[0];

    const isTableWithoutTopN = widget.type === TableSubType.Table && !widget.definition.custom.topN;
    const exportTop: TopResults | undefined =
      requestTop && !isTableWithoutTopN && top ? { size: top.size, groupOthers: top.groupOthers } : undefined;

    const isHistoricalFilterMode = Boolean(
      featureFlags[FeatureFlags.WidgetHistoricalFilterMode] &&
      widget.historicalFilterMode === HistoricalFilterMode.HISTORICAL &&
      isHistoricalQuery(widget.requests[0])
    );
    const cleanedFilters = cleanEmptyFilters(globalFilters);
    const contextFilter = isHistoricalFilterMode && cleanedFilters ? { ...cleanedFilters, isHistorical: true } : cleanedFilters;

    exportQueryObjectWorkflow({
      contextFilter,
      queryObject: {
        ...rest,
        ...(exportTop && { top: exportTop }),
        timezoneOffset: new Date().getTimezoneOffset(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      name: widget.definition.title.title,
    });
  };

  return { exportWidget, isExporting };
};
